/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Permanent session response DTO.
 */
export interface LakePermanentSessionResponse {
  userId: number;
  /**
   * Allowed IP addresses for the session. Supports CIDR format. \'|\' is a delimiter.
   */
  cidr?: string;
  /**
   * Allowed URL patterns for the session. \'|\' is a delimiter. Can optionally include an HTTP method
   */
  allowedUrlPatterns: string;
  /**
   * Description of the session.
   */
  description?: string;
  /**
   * The id of the permanent session.
   */
  id?: number;
  /**
   * The token of the permanent session.
   */
  token?: string;
  /**
   * The creation time of the session.
   */
  createTime?: string;
  active?: boolean;
}
